import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

export function OtherInfo({ children }) {
  return (
    <Stack
      sx={{
        width: '100%',
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
        gap: {
          xs: 3,
          sm: 5,
        },
      }}
    >
      {children}
    </Stack>
  );
}

OtherInfo.propTypes = {
  children: PropTypes.node,
};
